<template>
<el-dialog title="资源批量著录" :visible.sync="centerDialogVisible" width="860px" left>
  <el-form ref="form" :model="form" label-position="top" label-width="80px" :inline="false" size="normal">
    <el-row :gutter="20">
      <el-col :span="8" :offset="0">
        <el-form-item class="require" label="资源命名方式" prop="nametype" size="normal" :rules="[{required: true, message: '请选择资源命名方式', trigger: 'change'}]">

          <el-select v-model="form.nametype" style="width:100%" placeholder="">
            <el-option label="使用馆藏标题+序号命名" value="使用馆藏标题+序号命名" />
            <el-option label="使用资源文件名命名" value="使用资源文件名命名" />

          </el-select>

          <span class="placeholder-span">例：暑期社会实践传承红色基因助力建党百年-1</span>
        </el-form-item>

      </el-col>
      <el-col :span="16" :offset="0">
        <!-- :rules="[{required: true, message: '请输入标题', trigger: 'blur'}]"> -->
        <el-form-item label="批量资源描述" prop="descriptions" size="normal">
          <el-input v-model="form.descriptions" placeholder="" type="textarea" maxlength="50" show-word-limit size="small" clearable />

          <span class="placeholder-span">请概括填写本馆藏的内容副标题，最多50字</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-divider direction="horizontal" />
    <el-row :gutter="20">
      <el-col :span="8" :offset="0">

        <el-form-item label="资源体裁" prop="collectionLevel" size="normal">

          <!-- <el-select style="width:100%" v-model="form.collectionLevel" placeholder="">
            <el-option v-for="item in  collectionleverOptions" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey">
            </el-option>
          </el-select> -->
          <div style="100%">
            <el-cascader ref="cascaderhand" v-model="form.genre" style="100%" class="trantree" :show-all-levels="false" clearable :options="genretree" :props="genreProps" @change="changeCascan" />

          </div>
          <span class="placeholder-span">资源所属体裁</span>
        </el-form-item>

      </el-col>
      <el-col :span="8" :offset="0">
        <el-form-item label="创作日期" prop="dataTime" size="normal">

          <el-select v-model="form.dataTime" clearable style="width:100%" placeholder="">
            <el-option v-for="item in dataTimeList" :key="item" :label="item" :value="item" />
          </el-select>
          <span class="placeholder-span">资源创作日期</span>
        </el-form-item>
      </el-col>
      <el-col :span="8" :offset="0">
        <el-form-item label="纪事人物" prop="persons" size="normal">
          <el-select v-model="form.persons" style="width:100%" multiple collapse-tags filterable allow-create placeholder="">
            <el-option v-for="item in personsList" :key="item" :label="item" :value="item" />
          </el-select>
          <span class="placeholder-span">请选择</span>
        </el-form-item>

      </el-col>
    </el-row>
    <el-divider direction="horizontal" />
    <el-row :gutter="20">
      <el-col :span="8" :offset="0">

        <el-form-item label="内容语种" prop="contextlangue" size="normal">

          <el-select v-model="form.contextlangue" clearable style="width:100%" placeholder="">
            <el-option v-for="item in langueOptions" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
          </el-select>
          <span class="placeholder-span">适用于图片、文档、压缩包文件</span>
        </el-form-item>

      </el-col>
      <el-col :span="8" :offset="0">
        <el-form-item label="字幕语种" prop="textlangue" size="normal">

          <el-select v-model="form.textlangue" clearable style="width:100%" placeholder="">
            <el-option v-for="item in langueOptions" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
          </el-select>

          <span class="placeholder-span">适用于视频文件</span>
        </el-form-item>
      </el-col>
      <el-col :span="8" :offset="0">
        <el-form-item label="音频语种" prop="audiolangue" size="normal">
          <el-select v-model="form.audiolangue" clearable style="width:100%" placeholder="">
            <el-option v-for="item in langueOptions" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
          </el-select> <span class="placeholder-span">适用于视频、音频文件</span>
        </el-form-item>
      </el-col>
    </el-row>

  </el-form>
  <el-divider direction="horizontal" />
  <div class="bottom">
    <el-button class="btn-check" @click="selectImage('form')">保存</el-button>
    <el-button style="margin-left:20px" class="btn-off" @click="centerDialogVisible = false">取消</el-button>
  </div>

</el-dialog>
</template>

<script>
export default {
  data() {
    return {

      centerDialogVisible: false,

      langueOptions: [],
      genreProps: {
        children: 'children',
        value: 'genreName',
        label: 'genreName',
              expandTrigger: 'hover',
        checkStrictly: true // 可以选择任意一级
      },
      genretree: [],
      personsList: [],
      dataTimeList: [],
      form: {
        nametype: '使用资源文件名命名',
        descriptions: '',
        persons: '',
        dataTime: '',
        contextlangue: '',
        audiolangue: '',
        textlangue: '',
        genre: ''
      }
    }
  },
  mounted() {

  },
  methods: {
    changeCascan() {

      this.$refs.cascaderhand.dropDownVisible = false

    },
    isOpen(langueOptions,genretree, person, time) {
     

        this.langueOptions = langueOptions
   
      this.dataTimeList = time
      this.personsList = person
      this.genretree = genretree

      this.centerDialogVisible = true
    },
    selectImage(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.centerDialogVisible = false
          this.$emit('changeresourcedescription', this.form)
        } else {
          this.$message({
            message: '请注意必填项必须填写',
            type: 'error'
          })
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.trantree {
  .el-cascader-panel .el-radio {
    width: 100%;
    height: 100%;
    z-index: 10;
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .el-cascader-panel .el-radio__input {
    visibility: hidden;
  }

  .el-cascader-panel .el-cascader-node__postfix {
    top: 10px;
  }
}
.btn-check {
  width: 100px;
  height: 30px;
  background: #4C70E8;
  font-size: 14px;
  color: #ffffff;
  font-weight: bold;
  border-radius: 5px;
  padding: 0px;
}

.btn-off {
  width: 100px;
  height: 30px;
  background: #7B84A1;
  opacity: 0.5;
  border-radius: 5px;
  font-size: 14px;
  color: #ffffff;
  font-weight: bold;
  padding: 0px;
}

.bottom {
  padding: 18px 20px 18px;
  display: flex;
  justify-content: center;

}

::v-deep .el-textarea__inner {
  padding: 5px 10px;
  resize: none;
  height: 30px !important;
  border-radius: 0px;
  font-size: 12px;
  background-color: #F9F9FC;
  border: 1px solid #DEE0E7 !important;
}

::v-deep .el-dialog__body {
  padding: 0px 20px 20px 20px;

}

::v-deep .el-dialog__header {
  padding: 20px 20px;
}

::v-deep .el-dialog__title {
  height: 20px;
  font-size: 20px;

  font-weight: bold;
  color: #4C70E8;

}

::v-deep .el-divider--horizontal {

  margin: 20px 0;
}
</style>
